<template>
    <div :id="modalId" class="modal fade" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="header-title mt-0">GPS Updates</h4>
                </div>
                <div class="modal-body pb-3" style="max-height: 82vh; overflow-y: auto;">
                    <div v-if="!loading">
                        <DriverPositionUpdateMap
                            v-if="driverPositionUpdatesModalParameters !== null"
                            :key="mapKey"
                            :parameters="driverPositionUpdatesModalParameters"
                        />
                    </div>
                </div>
                <div class="modal-footer">
                    <Button class="btn btn-secondary" @click="close">
                        Close
                    </Button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import Button from "@components/Button.vue";
import DriverPositionUpdateMap from "@components/DriverPositionUpdateModalPlugin/DriverPositionUpdateMap.vue";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle";
import { computed, inject, onMounted, provide, ref, watch } from "vue";

const driverPositionUpdatesModalParameters = inject<any>("driverPositionUpdatesModalParameters");

const loading = ref(false);
const modalId = ref("DriverPositionUpdateModal");
//@ts-ignore
const modal = ref<null | bootstrap.Modal>(null);

// Signals to the map component that the modal animation has completed and the
// container has real dimensions — safe to initialise Google Maps.
const mapContainerReady = ref(false);
provide("mapContainerReady", mapContainerReady);

// Changing the key forces Vue to fully remount the map component whenever the
// user switches to a different booking or journey, guaranteeing a clean state.
const mapKey = computed(() =>
    driverPositionUpdatesModalParameters?.value?.bookingUuid
    ?? driverPositionUpdatesModalParameters?.value?.journeyUuid
    ?? "none"
);

const show = computed({
    get() { return driverPositionUpdatesModalParameters.value !== null; },
    set(value) { if (!value) driverPositionUpdatesModalParameters.value = null; },
});

const close = () => { show.value = false; };

watch(
    () => driverPositionUpdatesModalParameters.value,
    (newValue) => {
        if (newValue) {
            modal.value?.show();
        } else {
            modal.value?.hide();
        }
    }
);

onMounted(() => {
    const modalElement = document.getElementById(modalId.value);
    if (!modalElement) return;
    modal.value = new bootstrap.Modal(modalElement, {});

    // Signal ready only after the animation finishes so the map container has
    // real dimensions when Google Maps initialises.
    modalElement.addEventListener("shown.bs.modal", () => {
        mapContainerReady.value = true;
    });
    modalElement.addEventListener("hide.bs.modal", () => {
        mapContainerReady.value = false;
    });
});
</script>
